/* globals diy, cms */
var $ = require('jquery');
var l10n = require('diy/util/l10n');

module.exports = {
    getDialogTpl: function() {
        var msg = l10n.getMessages('domainConnection.improvedDialog');

        return ('' +
            '<div class="content-wrapper">' +
                '<div class="domain clearfix">' +
                    '<span class="promo-icon ui-icon-domain ui-icon-64"></span>' +
                    '<button class="blue-primary domain-connect-link" tabindex="-1">' +
                        '<span>' + msg.domain.button + '</span>' +
                    '</button>' +
                    '<div class="domain-content collapsed">' +
                        '<h3>' + msg.domain.heading + '</h3>' +
                        '<div class="short-desc">' +
                            '<p>' +
                                msg.domain.shortDescription +
                                ' <a href="Javascript:;" class="show-more" tabindex="-1">' +
                                    msg.domain.more +
                                '</a>' +
                            '</p>' +
                        '</div>' +
                        '<h3 class="long-desc">' + msg.domain.info + '</h3>' +
                        '<p class="long-desc">' +
                            msg.domain.shortDescription +
                            '<br /><br />' +
                            msg.domain.description +
                            ' <a href="Javascript:;" class="show-less" tabindex="-1">' +
                            msg.domain.less +
                            '</a></p>' +
                        '</p>' +
                    '</div>' +
                '</div>' +

                '<div class="contact clearfix">' +
                    '<span class="promo-icon ui-icon-contact ui-icon-64"></span>' +
                    '<button class="blue-secondary help-contact-link" tabindex="-1">' +
                        '<span>' + msg.customerCare.button + '</span>' +
                    '</button>' +
                    '<div class="contact-content">' +
                        '<h3>' + msg.customerCare.heading + '</h3>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );
    },

    init: function() {
        var msg = l10n.getMessages('domainConnection.improvedDialog');

        this.dlgEl = $(this.getDialogTpl()).appendTo('body').diy_dialog({
            dialogClass: 'diye-domainpromo-dialog cp-style',
            width: 800,
            zIndex: 200000,
            title: msg.windowTitle,
            draggable: false,
            resizable: false,
            closeButton: true,
            closeCls: 'ui-icon-24 ui-icon-24-xclose',
            modal: true,
            close: function() {
                $(document).trigger('diy-editor-generic-linkInteraction', {
                    actionName:'domainPopup_cancelTopUnset'
                });
            }
        });

        this.dlgEl.find('.show-more').click(function() {
            this.dlgEl.find('.domain-content').removeClass('collapsed');
        }.bind(this));

        this.dlgEl.find('.show-less').click(function() {
            this.dlgEl.find('.domain-content').addClass('collapsed');
        }.bind(this));

        this.dlgEl.find('button.domain-connect-link').click(this._onDomainConnectClick.bind(this));
        this.dlgEl.find('button.help-contact-link').click(function(e) {
            e.preventDefault();
            $(document).trigger('diy-editor-generic-linkInteraction', {actionName: 'getSupport'});
            cms.help.GuidedAssistant._instance.showHelpWindowTab(
                cms.help.GuidedAssistant._instance._options.controller.contactView
            );
            if (diy.tracking) {
                diy.tracking.addEventSuppression('diy-editor-generic-linkInteraction');
            }
            this.dlgEl.diy_dialog('close');
        }.bind(this));

    },

    _onDomainConnectClick: function(e) {
        e.preventDefault();
        this.openDomainConnect();
    },

    openDomainConnect: function() {
        $(document).trigger('diy-editor-generic-linkInteraction', {actionName: 'chooseDomain'});
        diy.util.redirector.redirectToLabel('domain_connect_redirect-promo');
    },

    show: function() {
        if (!this.dlgEl) {
            this.init();
        }
        this.dlgEl.diy_dialog('open');
        $(document).trigger('diy-editor-generic-sectionAccessed', {'sectionCodeName': 'domain-connection-pop-up'});
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/domainpromo/domainpromo.js
 ** module id = 546
 ** module chunks = 0
 **/